import React, { useState } from 'react';
import styled from '@emotion/styled';
import { InputText } from 'views/components/atoms/InputText';
import { Color, FontSize, MAX_WIDTH } from 'views/constants';
import { Button } from 'views/components/atoms/Button';
import { Typography } from 'views/components/atoms/Typography';
import { FormattedMessage, useIntl } from 'react-intl';
import { localeIds } from 'locals';
import { ErrorMessage } from 'views/components/molecules/ErrorMessage';

const InputAreaWrapper = styled.div`
  margin: 0;
  padding: 0 16px;
  background-color: ${Color.C6};
  border-bottom: 1px solid ${Color.C14};
`;

const ContentWrapper = styled.div`
  max-width: ${MAX_WIDTH};
  margin: auto;
  padding: 16px 0;
  &:not(:first-of-type) {
    border-top: 1px solid ${Color.C14};
  }
`;

interface InputAreaProps {
  setEnterpriseName(value: string): void;
}

const InputArea: React.FC<InputAreaProps> = ({ setEnterpriseName }) => {
  const intl = useIntl();
  return (
    <InputAreaWrapper>
      <ContentWrapper>
        <Typography el="p" size={FontSize.XS}>
          {intl.formatMessage({ id: localeIds.samlLoginForm.help })}
        </Typography>
      </ContentWrapper>
      <ContentWrapper>
        <InputText
          onChange={setEnterpriseName}
          placeholder={intl.formatMessage({
            id: localeIds.samlLoginForm.enterpriseName,
          })}
          type="text"
          required
        />
      </ContentWrapper>
      <ContentWrapper>
        <Typography el="p" size={FontSize.XS}>
          {intl.formatMessage({
            id: localeIds.samlLoginForm.enterpriseNameFormat,
          })}
        </Typography>
      </ContentWrapper>
    </InputAreaWrapper>
  );
};

const MessageWrapper = styled.div`
  padding-top: 16px;
  display: flex;
  justify-content: center;
`;

const ButtonWrapper = styled.div`
  width: ${MAX_WIDTH};
  margin: auto;
  padding-top: 16px;
`;

interface SamlLoginFormProps {
  errorMessage?: string;
  disabled?: boolean;
  onSamlLogin(enterpriseName: string): void;
}

export const SamlLoginForm: React.FC<SamlLoginFormProps> = ({
  errorMessage,
  disabled = false,
  onSamlLogin,
}) => {
  const [enterpriseName, setEnterpriseName] = useState('');
  const handleLogin = (event: React.FormEvent<HTMLFormElement>): void => {
    event.preventDefault();
    onSamlLogin(enterpriseName);
  };

  return (
    <form onSubmit={handleLogin}>
      <InputArea setEnterpriseName={setEnterpriseName} />

      {errorMessage ? (
        <MessageWrapper>
          <ErrorMessage message={errorMessage} maxWidth={MAX_WIDTH} />
        </MessageWrapper>
      ) : null}

      <ButtonWrapper>
        <Button type="submit" style="primary" disabled={disabled}>
          <FormattedMessage id={localeIds.samlLoginForm.submit} />
        </Button>
      </ButtonWrapper>
    </form>
  );
};
